const { btoau } = require('b2a');

const getDomainHost = hostname => {
  if (hostname.indexOf('binance.us') > -1) {
    hostname = 'https://accounts.binance.us';
  }
  if (hostname.indexOf('qafdg.us') > -1) {
    hostname = 'https://accounts.qafdg.us';
  }
  if (hostname.indexOf('localhost') > -1) {
    hostname = 'https://accounts.devfdg.us';
  }
  return hostname;
};

const getRouterConfig = () => {
  const routes = require('../config/router/global.json');
  return routes.reduce((pre, { page, needToken = false, fallbackUrl }) => {
    pre[page.replace(/^\/?/, '/')] = {
      needToken,
      fallbackUrl,
    };
    return pre;
  }, {});
};
const GLOBAL_ROUTE_CONFIG = getRouterConfig();
const USERCENTER_REGRX = /^\/usercenter/;
const LOGIN_REGISTER_URLS = ['/login', '/register'];
const checkLogin = (pathName) => {
  const { needToken, fallbackUrl } = GLOBAL_ROUTE_CONFIG[pathName] || {};
  const redirect = needToken || USERCENTER_REGRX.test(pathName);
  return {
    redirect,
    fallbackUrl,
  };
};

const handleAuth = ({
  req, res, route, query,
}) => {
  const { url, hostname, cookies: { logined } } = req;
  const { page } = route;
  const { locale } = query;
  let redirected = false;
  if (logined !== 'y') {
    const { redirect, fallbackUrl = url } = checkLogin(page);
    if (redirect) {
      redirected = true;
      const domainHost = getDomainHost(hostname);
      // there are only 2 pages being used in current us-exchange-ui:
      // https://www.binance.us/en/markets
      // https://www.binance.us/en/inmail
      // return urls can strat with 'https://www.binance.us'
      // whole return urls are provided to solve forwardMain & forwardAccount issue
      res.redirect(`${domainHost}/en/login?return_to=${btoau(domainHost.replace('accounts', 'www') + fallbackUrl.replace('%locale', locale))}`);
    }
  } else if (LOGIN_REGISTER_URLS.includes(page)) {
    redirected = true;
    res.redirect(`/${locale}/usercenter/dashboard/overview`);
  }
  return redirected;
};

const withoutLogin = (req, res, _next) => {
  const { logined } = req.cookies;
  const { locale } = req.params;
  if (logined === 'y') {
    res.redirect(`/${locale}/usercenter/dashboard/overview`);
    return;
  }
  _next();
};

module.exports = {
  checkLogin,
  handleAuth,
  withoutLogin,
};
